module.exports = __webpack_public_path__ + "static/media/daily discipline report.431553a2.svg";